import { _ as _baseGetTag } from "./auth-service-tools511.js";
import { i as isObject_1 } from "./auth-service-tools563.js";
var baseGetTag = _baseGetTag,
    isObject = isObject_1;
var asyncTag = "[object AsyncFunction]",
    funcTag = "[object Function]",
    genTag = "[object GeneratorFunction]",
    proxyTag = "[object Proxy]";

function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }

  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;
export { isFunction_1 as i };